import script from "./MessageReactionsModalItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageReactionsModalItem.vue?vue&type=script&setup=true&lang=ts"

import "./MessageReactionsModalItem.vue?vue&type=style&index=0&id=5120e25a&lang=scss"

const __exports__ = script;

export default __exports__